import { TradingHourDay } from '@scentregroup/shared/graphql'
import { ParsedBannerOpeningHour } from './types'
import { parseOpeningHours } from './parse-opening-hours'

export const parseCentreBannerHours = function parseCentreBannerHours(
  tradingHours: TradingHourDay[],
  centreTimeZone: string,
  centreFeatures?: string[]
): ParsedBannerOpeningHour {
  const defaultDay = { hours: [], text: { description: '', isColored: false } }
  const allHours = parseOpeningHours(
    tradingHours,
    centreTimeZone,
    centreFeatures
  )
  const today =
    allHours.find(tradingHour => tradingHour.day === 'Today') || defaultDay
  return {
    text: today.text,
    hours: today.hours.join(', '),
  }
}
